import CardItem from './CardItem.view';

export default CardItem;
